<template>
  <div>
    <button :style="buttonStyles" @click="handleGoogleMaps" class="map-button">Voltar</button>
    <div class="layout-container weather">
      <span class="interactive-map-weather-title">Clima em Foz do Iguaçu</span>
      <div>
        <div class="interactive-map-weather-progress-texts" style="margin-top: 20px">
          <span>-51ºC</span><span>-40</span><span>-29</span><span>-18</span> <span>-7</span
          ><span>4</span><span>16</span><span>27</span><span>38</span>
          <span>49</span>
        </div>
        <img src="/weather-progress.svg" alt="" />
        <div class="interactive-map-weather-main-icon weather-default-mb">
          <img :src="getIconUrl(currentWeather.icon)" :alt="currentWeather.description" />
        </div>
        <span class="interactive-map-weather-today-text weather-default-mb">
          Hoje - {{ customFormatter(new Date()) }}
        </span>
        <span class="interactive-map-weather-text weather-default-mb">
          {{ capitalize(currentWeather.description) }}
        </span>
        <span class="interactive-map-weather-graus-text weather-default-mb">
          Temperatura: {{ convertTemp(currentWeather.temp) }}º
        </span>
        <div class="interactive-map-weather-clime-text-container" style="margin-bottom: 20px">
          <span class="interactive-map-weather-clime-text">Chuva: {{ currentWeather.pop }}%</span>
          <span class="interactive-map-weather-clime-text"
            >Umidade: {{ currentWeather.humidity }}%</span
          >
          <span class="interactive-map-weather-clime-text"
            >Vento: {{ currentWeather.windSpeed }} m/s</span
          >
        </div>
        <div class="interactive-map-weather-card">
          <span class="interactive-map-weather-card-title weather-default-mb">Próximos 5 dias</span>
          <div class="interactive-map-weather-list">
            <div
              v-for="(day, index) in forecastWeather"
              :key="index"
              class="interactive-map-weather-list-block"
            >
              <div class="interactive-map-weather-list-content">
                <span class="interactive-map-weather-list-date-number"
                  >Dia {{ getDayNumber(day.dt) }} às {{ getHour(day.dt) }}</span
                >
                <span class="interactive-map-weather-list-text">{{ getDayName(day.dt) }}</span>
              </div>
              <div class="interactive-map-weather-list-content rain-block">
                <i :class="getWeatherIcon(day.weather[0].main)" style="margin-right: 10px"></i>
                <div style="display: flex; flex-direction: column !important">
                  <span class="interactive-map-weather-list-text">
                    <i class="fa-solid fa-arrow-down" style="color: #06b8ff"></i
                    >{{ convertTemp(day.temp_min) }}º
                  </span>
                  <span class="interactive-map-weather-list-text">
                    <i class="fa-solid fa-arrow-up" style="color: #f25362"></i
                    >{{ convertTemp(day.temp_max) }}º
                  </span>
                </div>
              </div>
              <div class="interactive-map-weather-list-content">
                <i class="fa-solid fa-water" style="color: #1aa1ff"></i>
                <span class="interactive-map-weather-list-text">{{ day.pop }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import axios from 'axios'
import { useCustomHeader } from '../../../../../../../stores/customHeader'
export default {
  name: 'Weather',
  props: {
    layoutType: String,
    isLoadingArravalsData: Boolean,
    cityCount: Array,
  },
  data() {
    return {
      currentWeather: {
        temp: 0,
        description: '',
        icon: '',
        pop: 0,
        humidity: 0,
        windSpeed: 0,
      },
      forecastWeather: [],
      buttonStyles: {
        backgroundColor: 'white',
        color: '#37434A',
        padding: '8px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '100px',
        border: 'none',
        cursor: 'pointer',
      },
    }
  },
  computed: {
    ...mapState(useCustomHeader, ['getSubtitleCustomHeader']),
    ...mapState(useCustomHeader, ['getDisableButtons']),
  },
  mounted() {
    this.fetchWeatherData()
  },
  methods: {
    handleGoogleMaps() {
      this.getSubtitleCustomHeader('Dados em tempo real')
      this.getDisableButtons(false)
      document.getElementById('interactive-map').style.display = 'block'
      document.getElementById('windy').style.display = 'none'
    },
    async fetchWeatherData() {
      // Simulando uma requisição fictícia com dados fornecidos
      const response = await axios.get('/api/transport-modes/interactive-map/weather')
      const data = response.data.list
      this.currentWeather = {
        temp: data[0].main.temp,
        description: data[0].weather[0].description,
        icon: data[0].weather[0].icon,
        pop: data[0].pop * 100,
        humidity: data[0].main.humidity,
        windSpeed: data[0].wind.speed,
      }

      this.forecastWeather = data.map((item) => ({
        dt: item.dt,
        temp_min: item.main.temp_min,
        temp_max: item.main.temp_max,
        pop: item.pop * 100,
        weather: item.weather,
      }))
    },
    getIconUrl(icon) {
      return `http://openweathermap.org/img/wn/${icon}.png`
    },
    convertTemp(kelvin) {
      return (kelvin - 273.15).toFixed(1)
    },
    customFormatter(date) {
      return date.toLocaleDateString('pt-BR', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    },
    getDayNumber(timestamp) {
      return new Date(timestamp * 1000).getDate()
    },
    getDayName(timestamp) {
      return new Date(timestamp * 1000).toLocaleDateString('pt-BR', { weekday: 'short' })
    },
    getWeatherIcon(weather) {
      switch (weather) {
        case 'Clear':
          return 'fa-solid fa-sun'
        case 'Clouds':
          return 'fa-solid fa-cloud'
        case 'Rain':
          return 'fa-solid fa-cloud-rain'
        default:
          return 'fa-solid fa-cloud'
      }
    },

    capitalize(str) {
      return str
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    },
    getHour(dt) {
      const date = new Date(dt * 1000)
      return date.getHours() + ':00'
    },
  },
}
</script>

<style src="../../styles.css"></style>
